import { render } from "./LoaderView.vue?vue&type=template&id=4f6716a8"
import script from "./LoaderView.vue?vue&type=script&lang=js"
export * from "./LoaderView.vue?vue&type=script&lang=js"

import "./LoaderView.vue?vue&type=style&index=0&id=4f6716a8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__